import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { DatePipe, DecimalPipe } from '@angular/common';


@Component({
  selector: 'app-invoice',
  templateUrl: './document.component.html',
  imports: [CentToEurDisplayDirective, DatePipe, DecimalPipe]
})
export class InvoiceTemplateComponent implements OnInit {

  public document: any = {}
  public client: any = {}
  public documentLines: any[] = []
  public tax: any = null
  public pay_method: any = null
  id: string | null = null
  type: string | null = null

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  @ViewChild('invoice')
  content!: ElementRef;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.type = this.route.snapshot.paramMap.get('type');
    this.getData(this.id);
  }

  getDocumentLabel(type: string): string {
    const labels: Record<string, string> = {
      'factura': 'Nº Factura',
      'albaran': 'Nº Albarán',
      'presupuesto': 'Nº Presupuesto'
    };
    return labels[type] ?? '';
  }

  private parseSpecialMeasures(value: any): any[] {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  }

  // Hasta 3 medidas por fila
  groupSpecialMeasures(value: any, size: number = 3): any[][] {
    const measures = this.parseSpecialMeasures(value);
    const groups: any[][] = [];
    for (let i = 0; i < measures.length; i += size) {
      groups.push(measures.slice(i, i + size));
    }
    return groups;
  }

  // generarPDF() {
  //   const element = document.getElementById('factura');

  //   if (!element) return;

  //   html2canvas(element, { scale: 2 }).then(canvas => {
  //     const imgData = canvas.toDataURL('image/png');

  //     const pdf = new jsPDF('p', 'mm', 'a4');

  //     const imgWidth = 210;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //     pdf.save('factura.pdf');
  //   });
  // }
  // Primera línea de producto, tanto si la factura tiene líneas propias como si
  // viene agrupada por albaranes (cada elemento trae sus `products`)
  get firstProductLine(): any {
    const first = this.documentLines?.[0];
    return first?.code ? first : first?.products?.[0];
  }

  getHtml(): string {
    return this.content.nativeElement.innerHTML;
  }

  getData(id: any): any {
    this.apiService.getById(Urls.urls.documents, id).subscribe({
          next: (data: any) => {
            this.document = data.document;
            this.client = data.client;
            this.documentLines = data.document_details;
            this.tax = data.tax;
            this.pay_method = data.pay_method;
            this.cdr.detectChanges();
            if(this.type === 'print') {
            window.print();
            }
          },
          error: (error: any) => {
            console.error('ERROR obtener productos. ' + error);
          },
      });
  }
}